import { useEffect, useRef, useState } from "react";
import useFetchAllCategories from "../../Hooks/useFetchAllCategories";
import CategoriesList from "./CategoriesList";
import CategoriesSkeleton from "./CategoriesSkeleton";
import "./dropdown.css";


const CategoriesDropDown = () => {
    const [isOpen, setIsOpen] = useState(false);
    // Short label on smaller laptops: the full one wrapped onto two lines in the navbar
    const [selectedCategory] = useState(
        <p className="text-primary-secondary whitespace-nowrap">
            <span className="xl:hidden">Catégories</span>
            <span className="hidden xl:inline">Sélectionner une catégorie</span>
        </p>
    );
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { loading } = useFetchAllCategories();

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div
            ref={dropdownRef}
            className={`custom-select ${isOpen ? "active" : ""}`}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <button
                className="select-button"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsOpen(!isOpen);
                }}
                type="button"
                aria-expanded={isOpen ? "true" : "false"}
                aria-label="select-dropdown"
            >
                <span className="selected-value">{selectedCategory}</span>
                <span className={`arrow ${isOpen ? "open" : ""}`}></span>
            </button>
            <ul className="select-dropdown">
                {loading ? <CategoriesSkeleton /> : <CategoriesList />}
            </ul>
        </div>
    );
};

export default CategoriesDropDown;
